export const ValidStrikeTypes = [1, 10, 20, 30, 40, 50, 100, 200] as const;

export const StrikePriceType = {
  // -1: 'Invalid',
  1: 'TWAP3',
  10: 'TWAP7',
  20: 'TWAP14',
  30: 'TWAP30',
  40: 'VWAP7',
  50: 'VWAP14',
  100: 'Fixed',
  200: 'Legacy',
} as const;
